import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import { Typography, Input, Button, Dropdown, Menu, Icon, message, Tabs } from "antd";
import { ContextAPI } from "../../../ContextAPI";
import { platformApi } from '../../../api';
import InvoiceTable from './InvoiceTable';

const { Item } = Menu;
const { Search } = Input;
const { Title } = Typography;
const { TabPane } = Tabs;

const SaleSparesInvoice = () => {
  const history = useHistory();
  const { loginCredintials } = useContext(ContextAPI);
  const isCEO = loginCredintials?.role === 'CEO';
  const [dataSource, setData] = useState([]);
  const [createAccess, setCreateAccess] = useState(false);
  const [modifyAccess, setModifyAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);
  const [printAccess, setPrintAccess] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState('');
  const [gst, setGst] = useState();
  const [activeTab, setActiveTab] = useState("PENDING"); // <-- default tab

  useEffect(() => {
    setGst(loginCredintials.branch[0].gst);
    loginCredintials.roleAccess &&
      loginCredintials.roleAccess.map((each) => {
        if (each.subModule === "counter_sale") {
          if (each.access.create) setCreateAccess(true);
          if (each.access.update) setModifyAccess(true);
          if (each.access.delete) setDeleteAccess(true);
          if (each.access.print) setPrintAccess(true);
        }
      });
    setPageData();
  }, []);

  useEffect(() => {
    setPageData(search);
  }, [page, limit, search, activeTab]); // <-- re-fetch when tab changes

  const getMenu = () => {
    let size = count / 10 + (count % 10 ? 1 : 0);
    const menus = [];
    menus.push(10);
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item onClick={() => { setLimit(menu); setPage(1); }} key={menu}>
        {menu}
      </Item>
    ));
  };

  const menu = <Menu>{getMenu()}</Menu>;

  const setPageData = (search, val) => {
    setSpinning(true);
    platformApi
      .post("/api/saleSpareInvoice/get", {
        page: val ? val : page,
        size: limit,
        searchString: search,
        status: activeTab=="PENDING" ? null : activeTab,
      })
      .then((result) => {
        setSpinning(false);
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            setData(response.data.saleSpareInvoice);
            setCount(response.data.count);
          } else {
            message.error("Unable to fetch sale spare invoice", 2);
          }
        } else {
          message.error("Unable to fetch sale spare invoice", 2);
        }
      })
      .catch((error) => {
        console.error("Error on Vehicle Sale spare invoice : ", error);
        message.error("Unable to fetch sale spare invoice", 2);
      });
  };

  const deleteData = (id) => {
    setSpinning(true);
    platformApi.delete("/api/saleSpareInvoice/" + id)
      .then(result => {
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            message.success("Counter Sale Deleted Successfully");
            setPageData();
          } else {
            setSpinning(false);
            message.error("Couldn't Remove Counter Sale");
          }
        } else {
          setSpinning(false);
          message.error("Couldn't Remove Counter Sale");
        }
      })
      .catch((err) => {
        setSpinning(false);
        console.error("Delete Error: ", err);
        message.error("Unable to Delete Counter Sale");
      });
  };

  return (
    <>
      <div className="accessories-head">
        <Title style={{ width: "60%" }} level={4}>
          Counter Sale [{count}]
          <span style={{ marginLeft: "1rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit} &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>

        <Search
          style={{ width: "30%" }}
          placeholder="Search Counter Sale"
          onSearch={(event) => {
            setPage(1);
            setSearch(event);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearch(null);
              setPage(1);
            }
          }}
        />

        <Button
          onClick={() => {
            history.push({
              pathname: '/autoadmin/counter_sale/:id',
              state: { gst },
            });
          }}
          style={{ margin: "0 3%", width: "20%" }}
          type="primary"
          disabled={!createAccess}
        >
          Add Counter Sale
        </Button>
      </div>

      {/* 🔹 Tabs for PENDING / PAID */}
      <Tabs
        defaultActiveKey="PENDING"
        activeKey={activeTab}
        onChange={(key) => {
          setActiveTab(key);
          setPage(1);
        }}
        style={{ marginTop: 10 }}
      >
        <Tabs.TabPane tab="Pending" key="PENDING" />
        <Tabs.TabPane tab="Paid" key="PAID" />
      </Tabs>

      {/* 🔹 Invoice Table */}
      <InvoiceTable
        gst={gst}
        dataSource={dataSource}
        spinner={spinning}
        deleteData={deleteData}
        modify={modifyAccess}
        setModifyAccess={setModifyAccess}
        pagination={{
          onChange: (page) => setPage(page),
          pageSize: limit,
          current: page,
          total: count,
          showQuickJumper: true,
        }}
        deleteAccess={deleteAccess}
        printAccess={printAccess}
        tab = {activeTab}
        refreshData = {()=>{setPageData()}}
      />
    </>
  );
};

export default SaleSparesInvoice;